import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class DocumentExpiryPrintReport extends Component {
  render() {
    
    const { transactions,total } = this.props;
    return (
        <Table celled fixed singleLine>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="4" style={{ textAlign:"center" }}>Documents Expiry Report</Table.HeaderCell>
        </Table.Row>
          <Table.Row>
              <Table.HeaderCell  style={{ textAlign:'center' }}>Sr</Table.HeaderCell>
              <Table.HeaderCell >Name</Table.HeaderCell>
              <Table.HeaderCell >Company</Table.HeaderCell>
              {/* <Table.HeaderCell width={2} style={{ textAlign:'center' }}>Plate#</Table.HeaderCell> */}
              <Table.HeaderCell style={{ textAlign:'center' }}>Expiry Date</Table.HeaderCell>
            </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map(transaction => (
            <Table.Row>
              <Table.Cell style={{ textAlign:'center' }}>{transaction.sr}</Table.Cell>
              <Table.Cell>{transaction.name}</Table.Cell>
              <Table.Cell>{transaction.company}</Table.Cell>
              {/* <Table.Cell style={{ textAlign:'center' }}>{transaction.plate}</Table.Cell> */}
              <Table.Cell style={{ textAlign:'center' }}>{transaction.expiry_date}</Table.Cell>
            </Table.Row>
            )
          )}

            {/* <Table.Row>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell colspan="3" style={{ textAlign:"left",fontSize:'15px' }}><b>{total}</b></Table.Cell>
             
            </Table.Row> */}

        </Table.Body>
      </Table>
    );
  }
}
export default DocumentExpiryPrintReport;
